/*eslint-disable */
import React, { useState, useEffect } from "react";
import {
    Modal,
} from "semantic-ui-react";
import OrderAgGridTable from "./../../components/common/orderadGridTable";
import allAxiosCommonTA from "./../axiosComponent/allAxiosCommonTA";
import AllotVehicle from './allotFromVehicleAvailability'

const IndentFromBookingModal = ({
    modalOpen,
    handleClose,
    auth,
    ...props
}) => {
    const [rowData, setRowData] = useState([]);
    const [loadingMessage, setLoadingMessage] = useState('Loading...');

    useEffect(() => {
        getBookingVehicle()
    }, [props.vehicleID]);

    const getBookingVehicle = () => {
        allAxiosCommonTA({ url: "/bookings/indent/planning/vehicle/" + props.vehicleID, method: "get" })
            .then((response) => {
                console.log(response)
                setRowData(response.data.data)
                if (response.data.data.length <= 0)
                    setLoadingMessage("No Record(s) Found")
            })
            .catch((err) => {
                console.log("err", err);
            });
    }

    var columnDefs = [
        {
            headerName: "Booking. No.",
            field: "booking_number",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Booking Date & Time.",
            field: "booking_date",
            minWidth: 180,
            sortable: true,
            filter: true,
        },
        {
            headerName: "Booking Branch",
            field: "booking_branch",
            minWidth: 180,
            sortable: true,
            filter: true,
        },
        {
            headerName: "Origin",
            field: "source",
            minWidth: 180,
            sortable: true,
            filter: true,
        },
        {
            headerName: "Destination",
            field: "destination",
            minWidth: 180,
            sortable: true,
            filter: true,
        },
        {
            headerName: "Billing Party",
            field: "billing_party_name",
            minWidth: 180,
            sortable: true,
            filter: true,
        },
        {
            headerName: "Shipping Line",
            field: "shipping_line_name",
            minWidth: 180,
            sortable: true,
            filter: true,
        },
        {
            headerName: "",
            field: "",
            cellRenderer: "AllotVehicle",
            minWidth: 180,
            sortable: true,
            filter: true
        }
    ]

    var frameworkcomponent = {
        AllotVehicle: AllotVehicle
    };

    return (
        <div>
            <Modal open={modalOpen} onCloseopenIndent={handleClose} size="fullscreen">
                <Modal.Header className="p-bold-100">
                    <div className="d-flex justify-content-between">
                        <label className="font-weight-normal">{"Indent"}</label>
                        <div className="form-inline">
                            <i onClick={handleClose} className="fas fa-times"></i>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Content scrolling>
                    <div>
                        <OrderAgGridTable
                            columnDefs={columnDefs}
                            pagination={false}
                            titleBarTitle=""
                            extracomponents={frameworkcomponent}
                            rowData={rowData}
                            suppressRowClickSelection={true}
                            enableCellChangeFlash={true}
                            keyIndex={"u_id"}
                            showFilter={false}
                            vehicleID={props.vehicleID}
                            loadingMessage={loadingMessage}
                        />
                    </div>
                </Modal.Content>
            </Modal>
        </div>
    );
};


export default IndentFromBookingModal;